import Vue from "vue"
import Router from 'vue-router'
import  {routers}  from './route'
import store from '../store'

Vue.use(Router)
// console.log(routers);
const routerConfig = {
	mode:'hash',
	routes: routers
}

const router = new Router(routerConfig);


export default router


// 路由跳转前触发
router.beforeEach((to,from,next) => {
	if(to.path !== '/login'){
        if(to.path == '/bigData'){
			next()
		}else{
			if(window.sessionStorage.getItem("rid") == '0'){
				if(window.sessionStorage.getItem("username") != null){
						next();
				}else{
					next({path:'/login'})
				}
			}else if(window.sessionStorage.getItem("rid") == '4'){
				if(window.sessionStorage.getItem("username") != null){
					
						if(to.path == '/home' || to.path === '/'){
							next({path:'/gttindex'})
						}else{
							next()
						}
				}else{
					next({path:'/login'})
				}
			}else{
				if(window.sessionStorage.getItem("username") != null){
					
						if(to.path == '/home' || to.path === '/'){
							next({path:'/sjjdlist'})
						}else{
							next()
						}
				}else{
					next({path:'/login'})
				}
			}
		}	
	}else{
		if(window.sessionStorage.getItem("rid") == '0'){
			if(window.sessionStorage.getItem("username") != null){
				next({path:'/'});
			}else{
				next();
			}
		}else if(window.sessionStorage.getItem("rid") == '4'){
			if(window.sessionStorage.getItem("username") != null){
				next({path:'/gttindex'});
			}else{
				next();
			}
		}else{
			if(window.sessionStorage.getItem("username") != null){
				next({path:'/sjjdlist'});
			}else{
				next();
			}
		}
	}
})

